export default __webpack_public_path__ + "static/media/virus5.8f38f996.png";